/* eslint-disable no-unused-vars*/
/* eslint-disable new-cap*/
import React, { Fragment } from 'react';
import {
  SettingOutlined,
  DashboardOutlined,
  HomeOutlined,
  LogoutOutlined,
  LockOutlined,
  CreditCardOutlined,
  ReadOutlined,
  CalendarOutlined,
  ControlOutlined,
  DollarOutlined,
  TeamOutlined,
  UserOutlined,
  OrderedListOutlined,
  SyncOutlined,
  WalletOutlined,
  GiftOutlined,
  TrophyTwoTone,
  MoneyCollectTwoTone,
  InfoCircleOutlined,
  StarOutlined,
  ThunderboltOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UsergroupAddOutlined,
  CrownOutlined,
  GlobalOutlined,
  PlayCircleOutlined,
} from '@ant-design/icons';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import { HasAccess } from '@permify/react-role';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getCookie, removeCookie, setCookie } from 'helper/cookie';
import { get } from 'lodash';
import { Badge, Layout, Menu, Spin } from 'antd';
import Color from 'constants/color';
import { useT } from 'i18n/index';
import { getTopupTotalCount } from 'api/topup';
import { NumberFormat } from 'helper/currency';
import { receiveMessage, sendMessage } from 'helper/broadcastCredits';
import { getCustomerById } from 'api/customer';
import CountdownButton from 'common/CountdownButton/countdownButton.common';
import {
  BetDealerIcon,
  ForwardingIcon,
  IconAnnounce,
  IconCreditsCard,
  IconDealer,
  IconNumberLimit,
  IconReport,
  IconSummaryExpenses,
} from 'common/SVG/svg.common';
import { useQuery } from 'react-query';
import { getThrustNotiDeleteCountAll } from 'api/thrust';
import styled from 'styled-components';
const { Sider } = Layout;
// import { useWebSocketContext } from 'src//hooks/activeUser';
// import { useSSEContext } from 'src//hooks/activeUserSSE';
import { usePollingContext } from 'src/hooks/activeUserLongPolling_bk';
import AssessmentIcon from '@mui/icons-material/Assessment'; // ใช้แทน IconReport
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet'; // ใช้แทน IconSummaryExpenses
import PaidIcon from '@mui/icons-material/Paid'; // ใช้แทน DollarOutlined
import AttachMoneyIcon from '@mui/icons-material/AttachMoney'; // อีก icon สำหรับ balance
import HomeIcon from '@mui/icons-material/Home';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn'; // แจ้งโอนเงิน
import DashboardIcon from '@mui/icons-material/Dashboard';
import StorageIcon from '@mui/icons-material/Storage'; // ดูทรัพยากร
import GroupAddIcon from '@mui/icons-material/GroupAdd'; // ข้อมูลผู้ใช้งาน
import PublicIcon from '@mui/icons-material/Public'; // สำหรับชื่อเว็บไซต์
import LockIcon from '@mui/icons-material/Lock'; // เปลี่ยนรหัสผ่าน
import LogoutIcon from '@mui/icons-material/Logout'; // ออกจากระบบ
import CancelScheduleSendIcon from '@mui/icons-material/CancelScheduleSend';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CampaignIcon from '@mui/icons-material/Campaign';
import ListAltIcon from '@mui/icons-material/ListAlt';
import SportsMmaIcon from '@mui/icons-material/SportsMma';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import PaidRoundedIcon from '@mui/icons-material/PaidRounded';
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';
import FormatListNumberedRoundedIcon from '@mui/icons-material/FormatListNumberedRounded';
import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded';
import {
  StarBorderOutlined,
  SendOutlined,
  AssessmentOutlined,
  RedeemOutlined,
  AccountBalanceWalletOutlined,
  InfoOutlined,
  Settings,
  EmojiEventsOutlined,
  AttachMoneyOutlined,
  AccountCircleOutlined,
} from '@mui/icons-material';

const activeColor = {
  color: '#FFFFFF',
  background: 'linear-gradient(118deg, #004D40, #00796B)', // RealWorld teal gradient
  submenu: 'linear-gradient(118deg, #E0F2F1, rgba(0, 77, 64, 0.2))', // Soft mint + transparent teal
  colorBlack: '#E0F2F1', // pastel text
  colorOcean: '#26A69A', // soft teal accent
};

interface PropsType {
  collapsed: boolean;
  setSideBarToggle: (value: boolean) => void;
  setTokenData: any;
  activeUsersCount?: number;
}

const initialState = {
  data: [],
  isLoading: true,
  isLoadingCategory: true,
  pagination: {
    total: 0,
    showSizeChanger: false,
    defaultPageSize: 10,
    current: 1,
    limit: 10,
    offset: 0,
    search: '',
  },
  search: {
    order_by: '',
    order_type: '',
  },
};

const badgeStyle: React.CSSProperties = {
  background: 'linear-gradient(135deg, #00b894, #0073e6)', // Gradient หรูหรา
  color: '#ffffff',
  fontWeight: 'bold',
  fontSize: '12px',
  boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)',
  padding: '4px 8px',
  borderRadius: '12px',
};

const StyledBadge = styled(Badge)`
  .ant-badge-count {
    background: linear-gradient(135deg, #30c948, #20c997);
    color: #ffffff;
    font-size: 12px;
    font-weight: 700;
    padding: 0 6px;
    border-radius: 10px;
    min-width: 22px;
    height: 22px;
    line-height: 22px;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.15);
    transition: all 0.3s ease;
    border: 2px solid #ffffff;

    &:hover {
      background: linear-gradient(135deg, #20c997, #30c948);
      transform: scale(1.05);
    }
  }
`;

const AsidebarLayouts = (props: PropsType) => {
  const isMobileView = useSelector(state => get(state, 'device.isMobileView', false));
  const { collapsed, setTokenData, setSideBarToggle } = props;
  const location = useLocation();
  const $t = useT();
  const { pathname } = location;
  const splitPathname = pathname.split('/');
  const pathName = splitPathname[2];
  const dataUser: any = getCookie('dataUser');
  const parseDataUser = dataUser ? JSON.parse(dataUser) : null;
  const [paginate, setPaginate] = useState<any>(initialState.pagination);
  const token = getCookie('access_tokenltl');
  const updateFetchData = getCookie('updateFetchData');
  const [totalMoneyTransfer, setTotalMoneyTransfer] = useState(0);
  const creditsLimit = getCookie('credits_limit');
  const credits = getCookie('credits');
  const point = getCookie('point');
  const pointForeign = getCookie('point_foreign');
  const pointStock = getCookie('point_stock');
  const [data, setData] = useState<any>(null);
  const [cookieCredits, setCookieCredits] = useState(getCookie('credits'));
  const [cookiePoint, setCookiePoint] = useState(getCookie('point'));
  const [cookiePointForeign, setCookiePointForeign] = useState(getCookie('point_foreign'));
  const [cookiePointStock, setCookiePointStock] = useState(getCookie('point_stock'));
  const [countNotiDelete, setCountNotiDelete] = useState(0);
  const { activeUsersCount } = usePollingContext();

  const fetchSetUpThrustInData = async ({ queryKey }: any) => {
    const [_key, { token, data }] = queryKey;
    const params = {
      thrust_noti_delete: 'Y',
    };

    try {
      const responseData = await getThrustNotiDeleteCountAll({ token, params });
      if (responseData?.status === 200) {
        const data = responseData.data?.data;
        return data;
      } else {
        throw new Error(`
               Failed to fetch Noti Thrust Delete: status: ${responseData?.status} message: ${
          responseData?.data?.message
        } svgIcon: warning header: ดึงข้อมูลไม่สำเร็จ confirmButtonText: ${$t('Close')} cancelButtonText: ''
            `);
      }
    } catch (error) {
      // console.error('Error fetching limitnumber data:', error);
      throw error; // โยนข้อผิดพลาดต่อไปเพื่อให้ useQuery สามารถจับได้
    }
  };

  // ใช้ useQuery ในการดึงข้อมูลและจัดการ cache
  const { data: dataNotiDeleteCount, isLoading: isLoadingDeleteCount } = useQuery(
    [`NotiThrustDeleteCount`, { token, data }],
    fetchSetUpThrustInData,
    {
      staleTime: 120000, // 2 minutes
      cacheTime: 300000, // 5 minutes
      refetchOnWindowFocus: false,
    },
  );

  useEffect(() => {
    if (!isLoadingDeleteCount) {
      // console.log(dataNotiDeleteCount)
      if (dataNotiDeleteCount) {
        setCountNotiDelete(dataNotiDeleteCount);
      }
    }
  }, [cookieCredits, cookiePointForeign, cookiePointStock, isLoadingDeleteCount]);

  useEffect(() => {
    const cleanup = receiveMessage((data: any) => {
      setData(data);
    });
    return cleanup;
  }, []);

  useEffect(() => {
    const broadcastChannel = new BroadcastChannel('my_channel');
    const handleBroadcast = (e: any) => {
      const newData = getCookie('credits');
      if (newData !== cookieCredits) {
        setCookieCredits(newData);
      }
    };

    broadcastChannel.addEventListener('message', handleBroadcast);

    // Clean up listener when component unmounts
    return () => {
      broadcastChannel.removeEventListener('message', handleBroadcast);
    };
  }, [cookieCredits]);

  useEffect(() => {
    const broadcastChannel = new BroadcastChannel('my_channel');
    const handleBroadcast = (e: any) => {
      const newData = getCookie('point');
      if (newData !== cookieCredits) {
        setCookiePointForeign(newData);
      }
    };

    broadcastChannel.addEventListener('message', handleBroadcast);

    // Clean up listener when component unmounts
    return () => {
      broadcastChannel.removeEventListener('message', handleBroadcast);
    };
  }, [cookiePoint]);

  useEffect(() => {
    const broadcastChannel = new BroadcastChannel('my_channel');
    const handleBroadcast = (e: any) => {
      const newData = getCookie('point_stock');
      if (newData !== cookieCredits) {
        setCookiePoint(newData);
      }
    };

    broadcastChannel.addEventListener('message', handleBroadcast);

    // Clean up listener when component unmounts
    return () => {
      broadcastChannel.removeEventListener('message', handleBroadcast);
    };
  }, [cookiePointForeign]);

  useEffect(() => {
    const broadcastChannel = new BroadcastChannel('my_channel');
    const handleBroadcast = (e: any) => {
      const newData = getCookie('point_foreign');
      if (newData !== cookieCredits) {
        setCookiePointStock(newData);
      }
    };

    broadcastChannel.addEventListener('message', handleBroadcast);

    // Clean up listener when component unmounts
    return () => {
      broadcastChannel.removeEventListener('message', handleBroadcast);
    };
  }, [cookiePointStock]);

  const fetchCustomerById = useCallback(
    async (query?: any) => {
      const params = {
        id: parseDataUser?.id,
      };
      try {
        const responseData = await getCustomerById({ token, params: params });
        if (responseData?.status === 200) {
          const { data } = responseData;
          sendMessage(data?.data);
        } else {
          console.error('Error fetching customer data:', responseData);
        }
      } catch (error) {
        console.error('Error fetching customer data:', error);
      }
    },
    [token, parseDataUser?.id],
  );

  const fetchMoneyTransferCount = useCallback(
    async (query?: any) => {
      const params = {
        limit: query?.limit ? query?.limit : paginate.limit,
        offset: query?.offset ? query?.offset : paginate.offset,
        order_by: 'id',
        order_type: 'DESC',
        total: query?.total ? query?.total : paginate.total,
        search: query?.search ? query?.search : null,
        topup_status: 'wait',
      };
      try {
        const responseData = await getTopupTotalCount({
          token,
          params: params,
        });
        if (responseData?.status === 200) {
          const { data } = responseData;
          setCookie('updateFetchData', 'false');
          setTotalMoneyTransfer(data?.data?.total);
          setPaginate((prevState: any) => {
            return {
              ...prevState,
              total: data?.data?.total,
              last_page: data?.data?.total / prevState.limit,
              current: prevState.current,
            };
          });
        } else {
          setCookie('updateFetchData', 'false');
          setTotalMoneyTransfer(0);
          setPaginate(initialState.pagination);
        }
      } catch (error) {}
    },
    [paginate.limit, token],
  );

  useEffect(() => {
    if (parseDataUser?.type === 'Masteradmin' || parseDataUser?.type === 'Admin') {
      if (token) {
        fetchMoneyTransferCount();
      }
    }
  }, [token, fetchMoneyTransferCount, updateFetchData]);

  const Logout = () => {
    removeCookie('access_tokenltl');
    removeCookie('refresh_tokenltl');
    removeCookie('expires_tokenltl');
    removeCookie('dataUser');
    removeCookie('sessionId');
    localStorage.clear();
    setTokenData(false);
  };

  const renderSettingAccountMenu = () => {
    if (parseDataUser?.type === 'Masteradmin' || parseDataUser?.type === 'Admin') {
      return (
        <>
          <Menu.SubMenu
            key="setting-sub"
            icon={<Settings style={{ color: activeColor.colorBlack }} />} // ใช้ MUI icon
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '0px',
              background:
                pathName === 'permission' ||
                pathName === 'roles' ||
                pathName === 'customer' ||
                pathName === 'lottery_type' ||
                pathName === 'group_user' ||
                pathName === 'type_number' ||
                pathName === 'award_type_format' ||
                pathName === 'manage_award_type_format' ||
                pathName === 'category' ||
                collapsed === true
                  ? activeColor.background
                  : '',
              color:
                pathName === 'permission' ||
                pathName === 'roles' ||
                pathName === 'customer' ||
                pathName === 'lottery_type' ||
                pathName === 'group_user' ||
                pathName === 'type_number' ||
                pathName === 'award_type_format' ||
                pathName === 'manage_award_type_format' ||
                pathName === 'category' ||
                collapsed === true
                  ? activeColor.color
                  : activeColor.colorBlack,
            }}
            title="ตั้งค่าระบบ"
          >
            <Menu.Item
              key="permission"
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link
                to="/backoffice/permission"
                onClick={() => {
                  if (isMobileView) {
                    setSideBarToggle(!collapsed);
                  }
                }}
              >
                <span className="nav-text">สิทธิ์การเข้าถึง</span>
              </Link>
            </Menu.Item>

            <Menu.Item
              key="roles"
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link
                to="/backoffice/roles"
                onClick={() => {
                  if (isMobileView) {
                    setSideBarToggle(!collapsed);
                  }
                }}
              >
                <span className="nav-text">บทบาท</span>
              </Link>
            </Menu.Item>

            <Menu.Item
              key="customer"
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/customer">
                <span className="nav-text">สมาชิก</span>
              </Link>
            </Menu.Item>

            <Menu.Item
              key="category"
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/category">
                <span className="nav-text">หมวดหมู่</span>
              </Link>
            </Menu.Item>

            <Menu.Item
              key="lottery_type"
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/lottery_type">
                <span className="nav-text">ประเภทหวย</span>
              </Link>
            </Menu.Item>

            <Menu.Item
              key="group_user"
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/group_user">
                <span className="nav-text">กลุ่มสายงาน</span>
              </Link>
            </Menu.Item>

            <Menu.Item
              key="type_number"
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/type_number">
                <span className="nav-text">ประเภทข้อมูลรูปแบบตัวเลข</span>
              </Link>
            </Menu.Item>

            <Menu.Item
              key="award_type_format"
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/award_type_format">
                <span className="nav-text">ประเภทรูปแบบออกรางวัล</span>
              </Link>
            </Menu.Item>

            <Menu.Item
              key="manage_award_type_format"
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/manage_award_type_format">
                <span className="nav-text">จัดการรูปแบบการออกรางวัล</span>
              </Link>
            </Menu.Item>
          </Menu.SubMenu>
          <Menu.SubMenu
            key="setting-information-owner"
            icon={<Settings style={{ color: activeColor.colorBlack }} />} // ใช้ MUI icon
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '0px',
              background: pathName === 'owner_information' || collapsed === true ? activeColor.background : '',
              color: pathName === 'owner_information' || collapsed === true ? activeColor.color : activeColor.colorBlack,
            }}
            title="ข้อมูล Owner"
          >
            <Menu.Item
              key="owner_information"
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link
                to="/backoffice/owner_information"
                onClick={() => {
                  if (isMobileView) {
                    setSideBarToggle(!collapsed);
                  }
                }}
              >
                <span className="nav-text">สมาชิก Owner ทั้งหมด</span>
              </Link>
            </Menu.Item>
            <Menu.Item
              key="owner_inactive"
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link
                to="/backoffice/owner_inactive"
                onClick={() => {
                  if (isMobileView) {
                    setSideBarToggle(!collapsed);
                  }
                }}
              >
                <span className="nav-text">สมาชิก Owner ที่ไม่ใช้งาน</span>
              </Link>
            </Menu.Item>
            <Menu.Item
              key="owner_topup"
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link
                to="/backoffice/owner_topup"
                onClick={() => {
                  if (isMobileView) {
                    setSideBarToggle(!collapsed);
                  }
                }}
              >
                <span className="nav-text">ข้อมูลการเติมเงิน Owner</span>
              </Link>
            </Menu.Item>
            <Menu.Item
              key="owner_report"
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link
                to="/backoffice/owner_report"
                onClick={() => {
                  if (isMobileView) {
                    setSideBarToggle(!collapsed);
                  }
                }}
              >
                <span className="nav-text">สรุปยอดการใช้งาน Owner</span>
              </Link>
            </Menu.Item>
            <Menu.Item
              key="owner_report_goverment"
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link
                to="/backoffice/owner_report_goverment"
                onClick={() => {
                  if (isMobileView) {
                    setSideBarToggle(!collapsed);
                  }
                }}
              >
                <span className="nav-text">สรุปยอดการใช้งานรัฐบาล Owner</span>
              </Link>
            </Menu.Item>
          </Menu.SubMenu>
          <Menu.SubMenu
            key="setting-history"
            icon={<Settings style={{ color: activeColor.colorBlack }} />} // ใช้ MUI icon
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '0px',
              background:
                pathName === 'bank_account' ||
                pathName === 'level' ||
                pathName === 'point' ||
                pathName === 'promotion' ||
                pathName === 'money_transfer' ||
                pathName === 'report_not_approved' ||
                pathName === 'report_approved' ||
                collapsed === true
                  ? activeColor.background
                  : '',
              color:
                pathName === 'bank_account' ||
                pathName === 'level' ||
                pathName === 'point' ||
                pathName === 'promotion' ||
                pathName === 'money_transfer' ||
                pathName === 'report_not_approved' ||
                pathName === 'report_approved' ||
                collapsed === true
                  ? activeColor.color
                  : activeColor.colorBlack,
            }}
            title="ตั้งค่าบัญชี | ค่าใช้บริการ"
          >
            <Menu.Item
              key="bank_account"
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link
                to="/backoffice/bank_account"
                onClick={() => {
                  if (isMobileView) {
                    setSideBarToggle(!collapsed);
                  }
                }}
              >
                <span className="nav-text">ข้อมูลบัญชีธนาคาร</span>
              </Link>
            </Menu.Item>
            <Menu.Item
              key="level"
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link
                to="/backoffice/level"
                onClick={() => {
                  if (isMobileView) {
                    setSideBarToggle(!collapsed);
                  }
                }}
              >
                <span className="nav-text">ระดับการใช้บริการสมาชิก</span>
              </Link>
            </Menu.Item>

            <Menu.Item
              key="point"
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link
                to="/backoffice/point"
                onClick={() => {
                  if (isMobileView) {
                    setSideBarToggle(!collapsed);
                  }
                }}
              >
                <span className="nav-text">จัดการค่าบริการสมาชิก</span>
              </Link>
            </Menu.Item>

            <Menu.Item
              key="promotion"
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link
                to="/backoffice/promotion"
                onClick={() => {
                  if (isMobileView) {
                    setSideBarToggle(!collapsed);
                  }
                }}
              >
                <span className="nav-text">ข้อมูลโปรโมชั่น</span>
              </Link>
            </Menu.Item>
          </Menu.SubMenu>
          <Menu.SubMenu
            key="setting-tutorial"
            icon={<PlayCircleIcon style={{ color: activeColor.colorBlack }} />} // ใช้ MUI icon แทน
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '0px',
              background: pathName === 'category_tutorial' || pathName === 'video_tutorial' || collapsed === true ? activeColor.background : '',
              color:
                pathName === 'category_tutorial' || pathName === 'video_tutorial' || collapsed === true ? activeColor.color : activeColor.colorBlack,
            }}
            title="ตั้งค่าสอนการใช้งานระบบ"
          >
            <Menu.Item
              key="category_tutorial"
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link
                to="/backoffice/category_tutorial"
                onClick={() => {
                  if (isMobileView) {
                    setSideBarToggle(!collapsed);
                  }
                }}
              >
                <span className="nav-text">หมวดหมู่สอนวิธีการใช้งาน</span>
              </Link>
            </Menu.Item>
            <Menu.Item
              key="video_tutorial"
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link
                to="/backoffice/video_tutorial"
                onClick={() => {
                  if (isMobileView) {
                    setSideBarToggle(!collapsed);
                  }
                }}
              >
                <span className="nav-text">วีดีโอ | วิธีการใช้งานระบบ</span>
              </Link>
            </Menu.Item>
          </Menu.SubMenu>
        </>
      );
    }
  };

  const renderSummaryAccounting = () => {
    if (parseDataUser?.type === 'Senior' || parseDataUser?.type === 'Master' || parseDataUser?.type === 'Agent') {
      return (
        <Menu.SubMenu
          key="summary-accounting"
          icon={<Settings style={{ color: activeColor.colorBlack }} />} // ใช้ MUI icon
          style={{
            paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '0px',
            background:
              pathName === 'report' ||
              pathName === 'summary_member_group' ||
              pathName === 'summary_dealer' ||
              pathName === 'forwarding' ||
              pathName === 'clear_balance' ||
              pathName === 'balance' ||
              collapsed === true
                ? activeColor.background
                : '',
            color:
              pathName === 'report' ||
              pathName === 'summary_member_group' ||
              pathName === 'summary_dealer' ||
              pathName === 'forwarding' ||
              pathName === 'clear_balance' ||
              pathName === 'balance' ||
              collapsed === true
                ? activeColor.color
                : activeColor.colorBlack,
          }}
          title="สรุปยอดบัญชี"
        >
          <Menu.Item
            key="report"
            icon={<AssessmentIcon />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
              background: pathName === 'report' ? activeColor.background : '',
              color: activeColor.color,
            }}
            onClick={() => {
              if (isMobileView) {
                setSideBarToggle(!collapsed);
              }
            }}
          >
            <Link to="/backoffice/report">
              <span className="nav-text">สรุปยอดได้เสีย</span>
            </Link>
          </Menu.Item>

          <Menu.Item
            key="summary_member_group"
            icon={<AccountBalanceWalletIcon />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
              background: pathName === 'summary_member_group' ? activeColor.background : '',
              color: activeColor.color,
            }}
            onClick={() => {
              if (isMobileView) {
                setSideBarToggle(!collapsed);
              }
            }}
          >
            <Link to="/backoffice/summary_member_group">
              <span className="nav-text">สรุปบัญชี สมาชิก</span>
            </Link>
          </Menu.Item>

          <Menu.Item
            key="clear_balance"
            icon={<PaidIcon />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
              background: pathName === 'clear_balance' ? activeColor.background : '',
              color: activeColor.color,
            }}
            onClick={() => {
              if (isMobileView) {
                setSideBarToggle(!collapsed);
              }
            }}
          >
            <Link to="/backoffice/clear_balance">
              <span className="nav-text">เคลียร์ยอด</span>
            </Link>
          </Menu.Item>

          <Menu.Item
            key="balance"
            icon={<AttachMoneyIcon />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
              background: pathName === 'balance' ? activeColor.background : '',
              color: activeColor.color,
            }}
            onClick={() => {
              if (isMobileView) {
                setSideBarToggle(!collapsed);
              }
            }}
          >
            <Link to="/backoffice/balance">
              <span className="nav-text">ปรับยอด</span>
            </Link>
          </Menu.Item>

          {parseDataUser?.type !== 'Agent' && (
            <Menu.Item
              key="report_in_owner"
              icon={<DollarOutlined />}
              style={{
                paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
                background: pathName === 'report_in_owner' ? activeColor.background : '',
                color: activeColor.color,
              }}
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/report_in_owner">
                <span className="nav-text">สรุปยอดแทง</span>
              </Link>
            </Menu.Item>
          )}
        </Menu.SubMenu>
      );
    }
    if (parseDataUser?.type === 'Owner') {
      return (
        <Menu.SubMenu
          key="summary-accounting"
          icon={<SettingOutlined />}
          style={{
            paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '0px',
            background:
              pathName === 'report' ||
              pathName === 'summary_member_group' ||
              pathName === 'summary_dealer' ||
              pathName === 'forwarding' ||
              pathName === 'clear_balance' ||
              pathName === 'balance' ||
              collapsed === true
                ? activeColor.background
                : '',
            color:
              pathName === 'report' ||
              pathName === 'summary_member_group' ||
              pathName === 'summary_dealer' ||
              pathName === 'forwarding' ||
              pathName === 'clear_balance' ||
              pathName === 'balance' ||
              collapsed === true
                ? activeColor.color
                : activeColor.colorBlack,
          }}
          title="สรุปยอดบัญชี"
        >
          <Menu.Item
            key="report"
            icon={<AssessmentIcon />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
              background: pathName === 'report' ? activeColor.background : '',
              color: activeColor.color,
            }}
            onClick={() => {
              if (isMobileView) {
                setSideBarToggle(!collapsed);
              }
            }}
          >
            <Link to="/backoffice/report">
              <span className="nav-text">สรุปยอดได้เสีย</span>
            </Link>
          </Menu.Item>

          <Menu.Item
            key="summary_member_group"
            icon={<AccountBalanceWalletIcon />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
              background: pathName === 'summary_member_group' ? activeColor.background : '',
              color: activeColor.color,
            }}
            onClick={() => {
              if (isMobileView) {
                setSideBarToggle(!collapsed);
              }
            }}
          >
            <Link to="/backoffice/summary_member_group">
              <span className="nav-text">สรุปบัญชี สมาชิก</span>
            </Link>
          </Menu.Item>

          <Menu.Item
            key="summary_dealer"
            icon={<AccountBalanceWalletIcon />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
              background: pathName === 'summary_dealer' ? activeColor.background : '',
              color: activeColor.color,
            }}
            onClick={() => {
              if (isMobileView) {
                setSideBarToggle(!collapsed);
              }
            }}
          >
            <Link to="/backoffice/summary_dealer">
              <span className="nav-text">สรุปบัญชี ดีลเลอร์</span>
            </Link>
          </Menu.Item>

          <Menu.Item
            key="forwarding"
            icon={<ForwardingIcon />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
              background: pathName === 'forwarding' ? activeColor.background : '',
              color: activeColor.color,
            }}
            onClick={() => {
              if (isMobileView) {
                setSideBarToggle(!collapsed);
              }
            }}
          >
            <Link to="/backoffice/forwarding">
              <span className="nav-text">บัญชีข้อมูลตัดส่งออก</span>
            </Link>
          </Menu.Item>

          <Menu.Item
            key="clear_balance"
            icon={<PaidIcon />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
              background: pathName === 'clear_balance' ? activeColor.background : '',
              color: activeColor.color,
            }}
            onClick={() => {
              if (isMobileView) {
                setSideBarToggle(!collapsed);
              }
            }}
          >
            <Link to="/backoffice/clear_balance">
              <span className="nav-text">เคลียร์ยอด</span>
            </Link>
          </Menu.Item>

          <Menu.Item
            key="balance"
            icon={<AttachMoneyIcon />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
              background: pathName === 'balance' ? activeColor.background : '',
              color: activeColor.color,
            }}
            onClick={() => {
              if (isMobileView) {
                setSideBarToggle(!collapsed);
              }
            }}
          >
            <Link to="/backoffice/balance">
              <span className="nav-text">ปรับยอด</span>
            </Link>
          </Menu.Item>

          <Menu.Item
            key="report_in_owner"
            icon={<DollarOutlined />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
              background: pathName === 'report_in_owner' ? activeColor.background : '',
              color: activeColor.color,
            }}
            onClick={() => {
              if (isMobileView) {
                setSideBarToggle(!collapsed);
              }
            }}
          >
            <Link to="/backoffice/report_in_owner">
              <span className="nav-text">สรุปยอดแทง</span>
            </Link>
          </Menu.Item>
        </Menu.SubMenu>
      );
    }
  };

  const renderSharedMenuPeriod = () => {
    if (parseDataUser?.type === 'Senior' || parseDataUser?.type === 'Master' || parseDataUser?.type === 'Agent') {
      return (
        <>
          <Menu.Item
            key="fighthing"
            icon={<ControlOutlined />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
              background: pathName === 'fighthing' ? activeColor.background : '',
              color: activeColor.color,
            }}
            onClick={() => {
              if (isMobileView) {
                setSideBarToggle(!collapsed);
              }
            }}
          >
            <Link to="/backoffice/fighthing">
              <span className="nav-text">ตั้งสู้</span>
            </Link>
          </Menu.Item>
          <Menu.Item
            key="setuptofight"
            icon={<WalletOutlined />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
              background: pathName === 'setuptofight' ? activeColor.background : '',
              color: activeColor.color,
            }}
            onClick={() => {
              if (isMobileView) {
                setSideBarToggle(!collapsed);
              }
            }}
          >
            <Link to="/backoffice/setuptofight">
              <span className="nav-text">ดูยอด</span>
            </Link>
          </Menu.Item>
          <Menu.Item
            key="fullnumber"
            icon={<OrderedListOutlined />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
              background: pathName === 'fullnumber' ? activeColor.background : '',
              color: activeColor.color,
            }}
            onClick={() => {
              if (isMobileView) {
                setSideBarToggle(!collapsed);
              }
            }}
          >
            <Link to="/backoffice/fullnumber">
              <span className="nav-text">ตั้งเลขเต็ม | เลขอั้น</span>
            </Link>
          </Menu.Item>
          <Menu.Item
            key="report"
            icon={<AssessmentIcon />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
              background: pathName === 'report' ? activeColor.background : '',
              color: activeColor.color,
            }}
            onClick={() => {
              if (isMobileView) {
                setSideBarToggle(!collapsed);
              }
            }}
          >
            <Link to="/backoffice/report">
              <span className="nav-text">ดูโพยลูกค้า</span>
            </Link>
          </Menu.Item>
        </>
      );
    } else if (parseDataUser?.type === 'Owner') {
      return (
        <>
          <Menu.Item
            key="limitnumber"
            icon={<ListAltIcon />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
              background: pathName === 'limitnumber' ? activeColor.background : '',
              color: activeColor.color,
            }}
            onClick={() => {
              if (isMobileView) {
                setSideBarToggle(!collapsed);
              }
            }}
          >
            <Link to="/backoffice/limitnumber">
              <span className="nav-text">จัดการเลขอั้น</span>
            </Link>
          </Menu.Item>
          <Menu.Item
            key="fighthing"
            icon={<SportsMmaIcon />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
              background: pathName === 'fighthing' ? activeColor.background : '',
              color: activeColor.color,
            }}
            onClick={() => {
              if (isMobileView) {
                setSideBarToggle(!collapsed);
              }
            }}
          >
            <Link to="/backoffice/fighthing">
              <span className="nav-text">ราคาตั้งสู้ | ยอดรับ</span>
            </Link>
          </Menu.Item>
          <Menu.Item
            key="setuptofight"
            icon={<AccountBalanceWalletIcon />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
              background: pathName === 'setuptofight' ? activeColor.background : '',
              color: activeColor.color,
            }}
            onClick={() => {
              if (isMobileView) {
                setSideBarToggle(!collapsed);
              }
            }}
          >
            <Link to="/backoffice/setuptofight">
              <span className="nav-text">ดูยอดรับ/ตัดยอด</span>
            </Link>
          </Menu.Item>
          <Menu.Item
            key="report"
            icon={<AssessmentIcon />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
              background: pathName === 'report' ? activeColor.background : '',
              color: activeColor.color,
            }}
            onClick={() => {
              if (isMobileView) {
                setSideBarToggle(!collapsed);
              }
            }}
          >
            <Link to="/backoffice/report">
              <span className="nav-text">ดูรายงานลูกค้า</span>
            </Link>
          </Menu.Item>
        </>
      );
    }
  };

  const renderSettingMenu = () => {
    if (parseDataUser.type === 'Owner') {
      return (
        <Menu.SubMenu
          key="setting-other"
          icon={<SettingsRoundedIcon />}
          style={{
            paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '0px',
            background:
              pathName === 'payrate' ||
              pathName === 'template_fighthing' ||
              pathName === 'template_limit' ||
              pathName === 'automatically_limitnumber' ||
              collapsed === true
                ? activeColor.background
                : '',
            color:
              pathName === 'payrate' ||
              pathName === 'template_limit' ||
              pathName === 'template_fighthing' ||
              pathName === 'automatically_limitnumber' ||
              collapsed === true
                ? activeColor.color
                : activeColor.colorBlack,
          }}
          title="ตั้งค่า"
        >
          <Menu.Item
            key="payrate"
            icon={<PaidRoundedIcon />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
              background: pathName === 'payrate' ? activeColor.background : '',
              color: activeColor.color,
            }}
            onClick={() => {
              if (isMobileView) {
                setSideBarToggle(!collapsed);
              }
            }}
          >
            <Link to="/backoffice/payrate">
              <span className="nav-text">อัตราจ่าย</span>
            </Link>
          </Menu.Item>
          <Menu.Item
            key="template_fighthing"
            icon={<TuneRoundedIcon />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
              background: pathName === 'template_fighthing' ? activeColor.background : '',
              color: activeColor.color,
            }}
            onClick={() => {
              if (isMobileView) {
                setSideBarToggle(!collapsed);
              }
            }}
          >
            <Link to="/backoffice/template_fighthing">
              <span className="nav-text">เทมเพลตตั้งสู้</span>
            </Link>
          </Menu.Item>
          <Menu.Item
            key="template_limit"
            icon={<FormatListNumberedRoundedIcon />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
              background: pathName === 'limitnumber' ? activeColor.background : '',
              color: activeColor.color,
            }}
            onClick={() => {
              if (isMobileView) {
                setSideBarToggle(!collapsed);
              }
            }}
          >
            <Link to="/backoffice/template_limit">
              <span className="nav-text">เทมเพลตเลขอั้น</span>
            </Link>
          </Menu.Item>
          {parseDataUser?.automatic_limit === 'Y' && (
            <Menu.Item
              key="automatically_limitnumber"
              icon={<AutoAwesomeRoundedIcon />}
              style={{
                paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
                background: pathName === 'automatically_limitnumber' ? activeColor.background : '',
                color: activeColor.color,
              }}
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/automatically_limitnumber">
                <span className="nav-text">เลขอั้นอัตโนมัติ</span>
              </Link>
            </Menu.Item>
          )}
        </Menu.SubMenu>
      );
    }
    if (parseDataUser?.type === 'Senior' || parseDataUser?.type === 'Master' || parseDataUser?.type === 'Agent') {
      return (
        <Menu.SubMenu
          key="setting-other"
          icon={<SettingsRoundedIcon />}
          style={{
            paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '0px',
            background:
              pathName === 'payrate' ||
              pathName === 'template_fighthing' ||
              pathName === 'template_limit' ||
              pathName === 'automatically_limitnumber' ||
              collapsed === true
                ? activeColor.background
                : '',
            color:
              pathName === 'payrate' ||
              pathName === 'template_limit' ||
              pathName === 'template_fighthing' ||
              pathName === 'automatically_limitnumber' ||
              collapsed === true
                ? activeColor.color
                : activeColor.colorBlack,
          }}
          title="ตั้งค่า"
        >
          <Menu.Item
            key="payrate"
            icon={<PaidRoundedIcon />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
              background: pathName === 'payrate' ? activeColor.background : '',
              color: activeColor.color,
            }}
            onClick={() => {
              if (isMobileView) {
                setSideBarToggle(!collapsed);
              }
            }}
          >
            <Link to="/backoffice/payrate">
              <span className="nav-text">อัตราจ่าย</span>
            </Link>
          </Menu.Item>
          <Menu.Item
            key="template_fighthing"
            icon={<TuneRoundedIcon />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
              background: pathName === 'template_fighthing' ? activeColor.background : '',
              color: activeColor.color,
            }}
            onClick={() => {
              if (isMobileView) {
                setSideBarToggle(!collapsed);
              }
            }}
          >
            <Link to="/backoffice/template_fighthing">
              <span className="nav-text">เทมเพลตตั้งสู้</span>
            </Link>
          </Menu.Item>
        </Menu.SubMenu>
      );
    }
  };

  const renderMenuOwner = () => {
    if (parseDataUser?.type === 'Owner') {
      return (
        <>
          <Menu.Item
            key="announce_owner"
            icon={<CampaignIcon />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
              background: pathName === 'announce_owner' ? activeColor.background : '',
              color: activeColor.color,
            }}
            onClick={() => {
              if (isMobileView) {
                setSideBarToggle(!collapsed);
              }
            }}
          >
            <Link to="/backoffice/announce_owner">
              <span className="nav-text">แจ้ง | ประกาศข้อมูล</span>
            </Link>
          </Menu.Item>

          <Menu.SubMenu
            key="setting-period"
            icon={<SettingOutlined />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '0px',
              background:
                pathName === 'period' ||
                pathName === 'fighthing' ||
                pathName === 'limitnumber' ||
                pathName === 'setuptofight' ||
                pathName === 'report' ||
                collapsed === true
                  ? activeColor.background
                  : '',
              color:
                pathName === 'period' ||
                pathName === 'fighthing' ||
                pathName === 'limitnumber' ||
                pathName === 'setuptofight' ||
                pathName === 'report' ||
                collapsed === true
                  ? activeColor.color
                  : activeColor.colorBlack,
            }}
            title="จัดการข้อมูลหวย"
          >
            <Menu.Item
              key="period"
              icon={<CalendarOutlined />}
              style={{
                paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
                background: pathName === 'period' ? activeColor.background : '',
                color: activeColor.color,
              }}
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/period">
                <span className="nav-text">ตั้งค่างวด</span>
              </Link>
            </Menu.Item>
            {renderSharedMenuPeriod()}
          </Menu.SubMenu>

          <Menu.Item
            key="prize_results"
            icon={<GiftOutlined />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
              background: pathName === 'prize_results' ? activeColor.background : '',
              color: activeColor.color,
            }}
            onClick={() => {
              if (isMobileView) {
                setSideBarToggle(!collapsed);
              }
            }}
          >
            <Link to="/backoffice/prize_results">
              <span className="nav-text">ตรวจผลรางวัล</span>
            </Link>
          </Menu.Item>

          {renderSummaryAccounting()}

          {renderSettingMenu()}

          <Menu.SubMenu
            key="setting-member"
            icon={<TeamOutlined />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '0px',
              background:
                pathName === 'member_senior' ||
                pathName === 'member_master' ||
                pathName === 'member_agent' ||
                pathName === 'member' ||
                pathName === 'member_member' ||
                pathName === 'member_staff' ||
                pathName === 'forwarding_user' ||
                pathName === 'control_rate' ||
                pathName === 'dealer' ||
                collapsed === true
                  ? activeColor.background
                  : '',
              color:
                pathName === 'member_senior' ||
                pathName === 'member_master' ||
                pathName === 'member_agent' ||
                pathName === 'member' ||
                pathName === 'member_member' ||
                pathName === 'member_staff' ||
                pathName === 'forwarding_user' ||
                pathName === 'control_rate' ||
                pathName === 'dealer' ||
                collapsed === true
                  ? activeColor.color
                  : activeColor.colorBlack,
            }}
            title="จัดการสมาชิก"
          >
            <Menu.Item
              key="member_senior"
              icon={<UserOutlined />}
              style={{
                paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
                background: pathName === 'member_senior' ? activeColor.background : '',
                color: activeColor.color,
              }}
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/member_senior">
                <span className="nav-text">สมาชิก Senior</span>
              </Link>
            </Menu.Item>
            <Menu.Item
              key="member_master"
              icon={<UserOutlined />}
              style={{
                paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
                background: pathName === 'member_master' ? activeColor.background : '',
                color: activeColor.color,
              }}
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/member_master">
                <span className="nav-text">สมาชิก Master</span>
              </Link>
            </Menu.Item>
            <Menu.Item
              key="member_agent"
              icon={<UserOutlined />}
              style={{
                paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
                background: pathName === 'member_agent' ? activeColor.background : '',
                color: activeColor.color,
              }}
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/member_agent">
                <span className="nav-text">สมาชิก Agent</span>
              </Link>
            </Menu.Item>
            <Menu.Item
              key="member_member"
              icon={<UserOutlined />}
              style={{
                paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
                background: pathName === 'member_member' ? activeColor.background : '',
                color: activeColor.color,
              }}
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/member_member">
                <span className="nav-text">สมาชิก Member</span>
              </Link>
            </Menu.Item>
            <Menu.Item
              key="member_staff"
              icon={<UserOutlined />}
              style={{
                paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
                background: pathName === 'member_staff' ? activeColor.background : '',
                color: activeColor.color,
              }}
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/member_staff">
                <span className="nav-text">สมาชิก พนักงานคีย์</span>
              </Link>
            </Menu.Item>

            <Menu.Item
              key="control_rate"
              icon={<CreditCardOutlined />}
              style={{
                paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
                background: pathName === 'control_rate' ? activeColor.background : '',
                color: activeColor.color,
              }}
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/control_rate">
                <span className="nav-text">ควบคุมยอดตั้งสู้</span>
              </Link>
            </Menu.Item>

            <Menu.Item
              key="dealer"
              icon={<IconDealer />}
              style={{
                paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
                background: pathName === 'dealer' ? activeColor.background : '',
                color: activeColor.color,
              }}
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/dealer">
                <span className="nav-text">สมาชิกดีลเลอร์</span>
              </Link>
            </Menu.Item>
          </Menu.SubMenu>

          <Menu.SubMenu
            key="setting-dealer"
            icon={<StarBorderOutlined />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '0px',
              background:
                pathName === 'awards_dealer' ||
                pathName === 'summary_dealer' ||
                pathName === 'entranch_to_play_dealer' ||
                pathName === 'dealer' ||
                collapsed === true
                  ? activeColor.background
                  : '',
              color:
                pathName === 'awards_dealer' ||
                pathName === 'summary_dealer' ||
                pathName === 'entranch_to_play_dealer' ||
                pathName === 'dealer' ||
                collapsed === true
                  ? activeColor.color
                  : activeColor.colorBlack,
            }}
            title="เจ้ามือส่งออก"
          >
            <Menu.Item
              key="forwarding_user"
              icon={<CreditCardOutlined />}
              style={{
                paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
                background: pathName === 'forwarding_user' ? activeColor.background : '',
                color: activeColor.color,
              }}
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/forwarding_user">
                <span className="nav-text">ส่งโพย</span>
              </Link>
            </Menu.Item>

            <Menu.Item
              key="entranch_to_play_dealer"
              icon={<SendOutlined />}
              style={{
                paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
                background: pathName === 'entanch_to_play_dealer' ? activeColor.background : '',
                color: activeColor.color,
              }}
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/entranch_to_play_dealer">
                <span className="nav-text">ส่งเว็ป</span>
              </Link>
            </Menu.Item>

            <Menu.Item
              key="forwarding"
              icon={<AssessmentOutlined />}
              style={{
                paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
                background: pathName === 'forwarding' ? activeColor.background : '',
                color: activeColor.color,
              }}
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/forwarding">
                <span className="nav-text">รายงานส่งออก</span>
              </Link>
            </Menu.Item>

            <Menu.Item
              key="awards_dealer"
              icon={<RedeemOutlined />}
              style={{
                paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
                background: pathName === 'awards_dealer' ? activeColor.background : '',
                color: activeColor.color,
              }}
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/awards_dealer">
                <span className="nav-text">ดูโพย | ผลรางวัล | ดีลเลอร์</span>
              </Link>
            </Menu.Item>

            <Menu.Item
              key="summary_dealer"
              icon={<AccountBalanceWalletOutlined />}
              style={{
                paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
                background: pathName === 'summary_dealer' ? activeColor.background : '',
                color: activeColor.color,
              }}
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/summary_dealer">
                <span className="nav-text">สรุปบัญชี ดีลเลอร์</span>
              </Link>
            </Menu.Item>
          </Menu.SubMenu>

          {parseDataUser?.type === 'Owner' && (
            <Menu.Item
              key="noti_delete_poit"
              icon={<InfoOutlined />}
              style={{
                paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
                background: pathName === 'noti_delete_poit' ? activeColor.background : '',
                color: activeColor.color,
              }}
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/noti_delete_poit">
                <span className="nav-text">
                  แจ้งยกเลิกโพยที่เกินเวลา
                  <Badge count={countNotiDelete} offset={[10, 0]} style={badgeStyle} />
                </span>
              </Link>
            </Menu.Item>
          )}

          <Menu.SubMenu
            key="setting-point"
            icon={<WalletOutlined />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '0px',
              background:
                pathName === 'topup' ||
                pathName === 'report_topup' ||
                pathName === 'topup_foreign' ||
                pathName === 'topup_stock' ||
                pathName === 'transfer_point' ||
                pathName === 'history_transfer_point' ||
                collapsed === true
                  ? activeColor.background
                  : '',
              color:
                pathName === 'topup' ||
                pathName === 'report_topup' ||
                pathName === 'topup_foreign' ||
                pathName === 'topup_stock' ||
                pathName === 'transfer_point' ||
                pathName === 'history_transfer_point' ||
                collapsed === true
                  ? activeColor.color
                  : activeColor.colorBlack,
            }}
            title="จัดการเครดิต(ค่าบริการ)"
          >
            <Menu.Item
              key="topup"
              icon={<CreditCardOutlined />}
              style={{
                paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
                background: pathName === 'topup' ? activeColor.background : '',
                color: activeColor.color,
              }}
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/topup">
                <span className="nav-text">เติมเครดิต</span>
              </Link>
            </Menu.Item>
            <Menu.Item
              key="transfer_point"
              icon={<SyncOutlined />}
              style={{
                paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
                background: pathName === 'transfer_point' ? activeColor.background : '',
                color: activeColor.color,
              }}
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/transfer_point">
                <span className="nav-text">โอนเครดิต </span>
              </Link>
            </Menu.Item>
            <Menu.Item
              key="report_topup"
              icon={<ReadOutlined />}
              style={{
                paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
                background: pathName === 'report_topup' ? activeColor.background : '',
                color: activeColor.color,
              }}
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/report_topup">
                <span className="nav-text">ประวัติการเติมเครดิต </span>
              </Link>
            </Menu.Item>

            <Menu.Item
              key="history_transfer_point"
              icon={<ReadOutlined />}
              style={{
                paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
                background: pathName === 'history_transfer_point' ? activeColor.background : '',
                color: activeColor.color,
              }}
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/history_transfer_point">
                <span className="nav-text">ประวัติการโอนเครดิต </span>
              </Link>
            </Menu.Item>
          </Menu.SubMenu>
        </>
      );
    }
  };

  const renderMenuSenior = () => {
    if (parseDataUser?.type === 'Senior') {
      return (
        <>
          <Menu.SubMenu
            key="setting-period"
            icon={<SettingOutlined />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '0px',
              background:
                pathName === 'period' ||
                pathName === 'fighthing' ||
                pathName === 'template_fighthing' ||
                pathName === 'automatically_limitnumber' ||
                collapsed === true
                  ? activeColor.background
                  : '',
              color:
                pathName === 'period' ||
                pathName === 'fighthing' ||
                pathName === 'template_fighthing' ||
                pathName === 'automatically_limitnumber' ||
                collapsed === true
                  ? activeColor.color
                  : activeColor.colorBlack,
            }}
            title="จัดการข้อมูลหวย"
          >
            {renderSharedMenuPeriod()}
          </Menu.SubMenu>
          {renderSummaryAccounting()}
          {renderSettingMenu()}
          <Menu.SubMenu
            key="setting-member"
            icon={<TeamOutlined />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '0px',
              background:
                pathName === 'member_senior' ||
                pathName === 'member_master' ||
                pathName === 'member_agent' ||
                pathName === 'member' ||
                pathName === 'member_member' ||
                pathName === 'member_staff' ||
                pathName === 'control_rate' ||
                collapsed === true
                  ? activeColor.background
                  : '',
              color:
                pathName === 'member_senior' ||
                pathName === 'member_master' ||
                pathName === 'member_agent' ||
                pathName === 'member' ||
                pathName === 'member_member' ||
                pathName === 'member_staff' ||
                pathName === 'control_rate' ||
                collapsed === true
                  ? activeColor.color
                  : activeColor.colorBlack,
            }}
            title="จัดการสมาชิก"
          >
            <Menu.Item
              key="member_master"
              icon={<UserOutlined />}
              style={{
                paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
                background: pathName === 'member_master' ? activeColor.background : '',
                color: activeColor.color,
              }}
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/member_master">
                <span className="nav-text">สมาชิก Master</span>
              </Link>
            </Menu.Item>
            <Menu.Item
              key="member_agent"
              icon={<UserOutlined />}
              style={{
                paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
                background: pathName === 'member_agent' ? activeColor.background : '',
                color: activeColor.color,
              }}
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/member_agent">
                <span className="nav-text">สมาชิก Agent</span>
              </Link>
            </Menu.Item>
            <Menu.Item
              key="member_member"
              icon={<UserOutlined />}
              style={{
                paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
                background: pathName === 'member_member' ? activeColor.background : '',
                color: activeColor.color,
              }}
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/member_member">
                <span className="nav-text">สมาชิก Member</span>
              </Link>
            </Menu.Item>
            <Menu.Item
              key="member_staff"
              icon={<UserOutlined />}
              style={{
                paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
                background: pathName === 'member_staff' ? activeColor.background : '',
                color: activeColor.color,
              }}
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/member_staff">
                <span className="nav-text">สมาชิก พนักงานคีย์</span>
              </Link>
            </Menu.Item>

            <Menu.Item
              key="control_rate"
              icon={<CreditCardOutlined />}
              style={{
                paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
                background: pathName === 'control_rate' ? activeColor.background : '',
                color: activeColor.color,
              }}
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/control_rate">
                <span className="nav-text">ควบคุมยอดตั้งสู้สมาชิก</span>
              </Link>
            </Menu.Item>
          </Menu.SubMenu>
        </>
      );
    }
  };

  const renderMenuMaster = () => {
    if (parseDataUser?.type === 'Master') {
      return (
        <>
          <Menu.SubMenu
            key="setting-period"
            icon={<SettingOutlined />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '0px',
              background:
                pathName === 'period' ||
                pathName === 'fighthing' ||
                pathName === 'template_fighthing' ||
                pathName === 'automatically_limitnumber' ||
                collapsed === true
                  ? activeColor.background
                  : '',
              color:
                pathName === 'period' ||
                pathName === 'fighthing' ||
                pathName === 'template_fighthing' ||
                pathName === 'automatically_limitnumber' ||
                collapsed === true
                  ? activeColor.color
                  : activeColor.colorBlack,
            }}
            title="จัดการข้อมูลหวย"
          >
            {renderSharedMenuPeriod()}
          </Menu.SubMenu>
          {renderSummaryAccounting()}
          {renderSettingMenu()}
          <Menu.SubMenu
            key="setting-member"
            icon={<TeamOutlined />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '0px',
              background:
                pathName === 'member_senior' ||
                pathName === 'member_master' ||
                pathName === 'member_agent' ||
                pathName === 'member' ||
                pathName === 'member_member' ||
                pathName === 'member_staff' ||
                pathName === 'control_rate' ||
                collapsed === true
                  ? activeColor.background
                  : '',
              color:
                pathName === 'member_senior' ||
                pathName === 'member_master' ||
                pathName === 'member_agent' ||
                pathName === 'member' ||
                pathName === 'member_member' ||
                pathName === 'member_staff' ||
                pathName === 'control_rate' ||
                collapsed === true
                  ? activeColor.color
                  : activeColor.colorBlack,
            }}
            title="จัดการสมาชิก"
          >
            <Menu.Item
              key="member_agent"
              icon={<UserOutlined />}
              style={{
                paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
                background: pathName === 'member_agent' ? activeColor.background : '',
                color: activeColor.color,
              }}
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/member_agent">
                <span className="nav-text">สมาชิก Agent</span>
              </Link>
            </Menu.Item>
            <Menu.Item
              key="member_member"
              icon={<UserOutlined />}
              style={{
                paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
                background: pathName === 'member_member' ? activeColor.background : '',
                color: activeColor.color,
              }}
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/member_member">
                <span className="nav-text">สมาชิก Member</span>
              </Link>
            </Menu.Item>
            <Menu.Item
              key="member_staff"
              icon={<UserOutlined />}
              style={{
                paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
                background: pathName === 'member_staff' ? activeColor.background : '',
                color: activeColor.color,
              }}
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/member_staff">
                <span className="nav-text">สมาชิก พนักงานคีย์</span>
              </Link>
            </Menu.Item>
            <Menu.Item
              key="control_rate"
              icon={<CreditCardOutlined />}
              style={{
                paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
                background: pathName === 'control_rate' ? activeColor.background : '',
                color: activeColor.color,
              }}
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/control_rate">
                <span className="nav-text">ควบคุมยอดตั้งสู้สมาชิก</span>
              </Link>
            </Menu.Item>
          </Menu.SubMenu>
        </>
      );
    }
  };

  const renderMenuAgent = () => {
    if (parseDataUser?.type === 'Agent') {
      return (
        <>
          <Menu.SubMenu
            key="setting-period"
            icon={<SettingOutlined />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '0px',
              background:
                pathName === 'period' ||
                pathName === 'fighthing' ||
                pathName === 'template_fighthing' ||
                pathName === 'automatically_limitnumber' ||
                collapsed === true
                  ? activeColor.background
                  : '',
              color:
                pathName === 'period' ||
                pathName === 'fighthing' ||
                pathName === 'template_fighthing' ||
                pathName === 'automatically_limitnumber' ||
                collapsed === true
                  ? activeColor.color
                  : activeColor.colorBlack,
            }}
            title="จัดการข้อมูลหวย"
          >
            {renderSharedMenuPeriod()}
          </Menu.SubMenu>
          {renderSummaryAccounting()}
          {renderSettingMenu()}
          <Menu.SubMenu
            key="setting-member"
            icon={<TeamOutlined />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '0px',
              background:
                pathName === 'member_senior' ||
                pathName === 'member_master' ||
                pathName === 'member_agent' ||
                pathName === 'member' ||
                pathName === 'member_member' ||
                pathName === 'member_staff' ||
                pathName === 'control_rate' ||
                collapsed === true
                  ? activeColor.background
                  : '',
              color:
                pathName === 'member_senior' ||
                pathName === 'member_master' ||
                pathName === 'member_agent' ||
                pathName === 'member' ||
                pathName === 'member_member' ||
                pathName === 'member_staff' ||
                pathName === 'control_rate' ||
                collapsed === true
                  ? activeColor.color
                  : activeColor.colorBlack,
            }}
            title="จัดการสมาชิก"
          >
            <Menu.Item
              key="member_member"
              icon={<UserOutlined />}
              style={{
                paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
                background: pathName === 'member_member' ? activeColor.background : '',
                color: activeColor.color,
              }}
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/member_member">
                <span className="nav-text">สมาชิก Member</span>
              </Link>
            </Menu.Item>
            <Menu.Item
              key="member_staff"
              icon={<UserOutlined />}
              style={{
                paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
                background: pathName === 'member_staff' ? activeColor.background : '',
                color: activeColor.color,
              }}
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/member_staff">
                <span className="nav-text">สมาชิก พนักงานคีย์</span>
              </Link>
            </Menu.Item>
          </Menu.SubMenu>
        </>
      );
    }
  };

  const renderEntranceToPlay = () => {
    if (parseDataUser?.type === 'Agent' || parseDataUser?.type === 'Master' || parseDataUser?.type === 'Senior' || parseDataUser?.type === 'Member') {
      return (
        <>
          <Menu.Item
            key="entranch_to_play"
            icon={<EmojiEventsOutlined />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
              background: pathName === 'entranch_to_play' ? activeColor.background : '',
              color: activeColor.color,
            }}
            onClick={() => {
              if (isMobileView) {
                setSideBarToggle(!collapsed);
              }
            }}
          >
            <Link to="/backoffice/entranch_to_play">
              <span className="nav-text">หน้าแทงหวย</span>
            </Link>
          </Menu.Item>

          <Menu.Item
            key="check_payrate"
            icon={<AttachMoneyOutlined />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
              background: pathName === 'check_payrate' ? activeColor.background : '',
              color: activeColor.color,
            }}
            onClick={() => {
              if (isMobileView) {
                setSideBarToggle(!collapsed);
              }
            }}
          >
            <Link to="/backoffice/check_payrate">
              <span className="nav-text">ราคาจ่าย</span>
            </Link>
          </Menu.Item>

          <Menu.Item
            key="summary_expenses"
            icon={<AccountBalanceWalletOutlined />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
              background: pathName === 'summary_expenses' ? activeColor.background : '',
              color: activeColor.color,
            }}
            onClick={() => {
              if (isMobileView) {
                setSideBarToggle(!collapsed);
              }
            }}
          >
            <Link to="/backoffice/summary_expenses">
              <span className="nav-text">บัญชีของคุณ</span>
            </Link>
          </Menu.Item>

          {(parseDataUser?.type === 'Agent' || parseDataUser?.type === 'Master' || parseDataUser?.type === 'Senior') && (
            <Menu.Item
              key="summary_expenses_master"
              icon={<AccountCircleOutlined />}
              style={{
                paddingLeft: isMobileView ? '0px' : collapsed ? '0px' : '24px',
                background: pathName === 'summary_expenses_master' ? activeColor.background : '',
                color: activeColor.color,
              }}
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/summary_expenses_master">
                <span className="nav-text">บัญชีที่คุณแทงเอง</span>
              </Link>
            </Menu.Item>
          )}

          <Menu.Item
            key="awards"
            icon={<RedeemOutlined />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
              background: pathName === 'awards' ? activeColor.background : '',
              color: activeColor.color,
            }}
            onClick={() => {
              if (isMobileView) {
                setSideBarToggle(!collapsed);
              }
            }}
          >
            <Link to="/backoffice/awards">
              <span className="nav-text">ดูโพย | ผลรางวัล</span>
            </Link>
          </Menu.Item>

          {/* </Menu.SubMenu> */}
        </>
      );
    }
  };

  const renderEntranceToPlayStaff = () => {
    if (parseDataUser?.type === 'Staff') {
      return (
        <>
          <Menu.Item
            key="entranch_to_play_staff"
            icon={<EmojiEventsOutlined />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
              background: pathName === 'entranch_to_play_staff' ? activeColor.background : '',
              color: activeColor.color,
            }}
            onClick={() => {
              if (isMobileView) {
                setSideBarToggle(!collapsed);
              }
            }}
          >
            <Link to="/backoffice/entranch_to_play_staff">
              <span className="nav-text">เข้าคีย์หวย</span>
            </Link>
          </Menu.Item>
          <Menu.Item
            key="awards_staff"
            icon={<RedeemOutlined />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
              background: pathName === 'awards_staff' ? activeColor.background : '',
              color: activeColor.color,
            }}
            onClick={() => {
              if (isMobileView) {
                setSideBarToggle(!collapsed);
              }
            }}
          >
            <Link to="/backoffice/awards_staff">
              <span className="nav-text">ดูโพย | ผลรางวัล</span>
            </Link>
          </Menu.Item>
          {/* </Menu.SubMenu> */}
        </>
      );
    }
  };

  const renderOwnerPoints = (commonStyle: any) => (
    <>
      <p style={commonStyle}>ยูสเซอร์ {parseDataUser?.username}</p>
      <p style={commonStyle}>ระดับสมาชิก {parseDataUser?.type}</p>
      <p style={commonStyle}>เครดิตรัฐบาล {NumberFormat(point)}</p>
      <p style={commonStyle}>เครดิตต่างประเทศ {NumberFormat(pointForeign)}</p>
      <p style={commonStyle}>เครดิตหุ้นต่างประเทศ {NumberFormat(pointStock)}</p>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CountdownButton
          initialCount={60}
          buttonId={`update_credits_user`}
          text="อัปเดตเครดิต"
          showTime={false}
          functionGetData={fetchCustomerById}
        />
      </div>
    </>
  );

  const renderUserPoints = (commonStyle: any) => (
    <>
      <p style={commonStyle}>ยูสเซอร์ {parseDataUser?.username}</p>
      <p style={commonStyle}>ระดับสมาชิก {parseDataUser?.type}</p>
      <p style={commonStyle}>วงเงินเครดิต {NumberFormat(creditsLimit)}</p>
      <p style={commonStyle}>เครดิตที่ใช้ได้ {NumberFormat(credits)}</p>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CountdownButton
          initialCount={60}
          buttonId={`update_credits_user`}
          text="อัปเดตเครดิต"
          showTime={false}
          functionGetData={fetchCustomerById}
        />
      </div>
    </>
  );

  const renderUserStaff = (commonStyle: any) => (
    <>
      <p style={commonStyle}>ยูสเซอร์ {parseDataUser?.username}</p>
      <p style={commonStyle}>ระดับสมาชิก {parseDataUser?.type}</p>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CountdownButton
          initialCount={60}
          buttonId={`update_credits_user`}
          text="อัปเดตเครดิต"
          showTime={false}
          functionGetData={fetchCustomerById}
        />
      </div>
    </>
  );

  const renderShowPoint = () => {
    const isOwner = parseDataUser?.type === 'Owner';
    const commonStyle = { color: Color.white, paddingLeft: '10px' };
    if (isOwner) {
      return renderOwnerPoints(commonStyle);
    } else if (parseDataUser?.type === 'Masteradmin' || parseDataUser?.type === 'Admin') {
      return null;
    } else if (parseDataUser?.type === 'Staff') {
      return renderUserStaff(commonStyle);
    } else {
      return renderUserPoints(commonStyle);
    }
  };

  //  const openKeys =  [
  //    'setting-history',
  //    'setting-control-member',
  //    'setting-period',
  //    'setting-point',
  //    'setting-member',
  //    'entranch-to-play',
  //    'entranch-to-play-staff',
  //    'setting-sub',
  //    'setting-dealer',
  //    'cut-send',
  //    'summary-accounting',
  // ];

  const LogoContainer = styled.div`
    display: flex;
    align-items: left;
    justify-content: flex-start;
    flex-direction: row;
    padding: 15px 10px;
    height: 60px; // Adjust the height as needed
  `;

  const Title = styled.h5`
    color: ${Color.white};
    margin: 0;
  `;

  const Trigger = styled.span`
    position: absolute;
    cursor: pointer;
    top: 0px;
    right: 10px;
    color: ${Color.white};
  `;
  return (
    <Fragment>
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        style={{
          height: '100vh', // Full viewport height
          overflowY: 'auto', // Enables vertical scrolling
        }}
        className={isMobileView && collapsed === true ? 'mobile-collapsed' : collapsed === true ? 'desktop-collapsed' : ''}
        // style={{ overflow: 'auto' }}
        // style={{ height: isMobileView ? '100%' : '100%' }}
      >
        <Link to="/backoffice/homepage" key={'homepage'}>
          <LogoContainer className="logo">
            <Title className="text-center">
              <b>lotto-demo</b>
            </Title>
            {isMobileView && (
              <Trigger className="trigger" onClick={() => setSideBarToggle(!collapsed)}>
                {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              </Trigger>
            )}
          </LogoContainer>
        </Link>
        {renderShowPoint()}
        <Menu
          theme="light"
          mode="inline"
          // defaultOpenKeys={openKeys}
          defaultSelectedKeys={pathName ? [`${pathName}`] : ['backoffice']}
          selectedKeys={pathName ? [`${pathName}`] : ['backoffice']}
          style={{ overflow: 'auto' }}
          // selectedKeys={pathName ? pathName === 'homepage' && isMobileView === true ? splitPathname[1] : false ? false : splitPathname[1] : false}
        >
          {isMobileView ? (
            <Menu.Item
              key="homepage"
              icon={<HomeIcon />}
              style={{
                paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
                background: pathName === 'homepage' ? activeColor.background : '',
                color: activeColor.color,
              }}
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/homepage">
                <span className="nav-text">หน้าหลัก</span>
              </Link>
            </Menu.Item>
          ) : (
            <></>
          )}
          <HasAccess roles={['Masteradmin']} permissions={['dashboard-menu']} isLoading={<Spin />}>
            <Menu.Item
              key="money_transfer"
              icon={<MonetizationOnIcon />}
              style={{
                paddingLeft: collapsed ? '0px' : '24px',
                background: pathName === 'money_transfer' ? activeColor.background : '',
                color: pathName === 'money_transfer' ? activeColor.color : undefined,
              }}
              onClick={() => {
                if (isMobileView) setSideBarToggle(!collapsed);
              }}
            >
              <Link to="/backoffice/money_transfer">
                <span className="nav-text">
                  แจ้งเตือนการโอนเงิน <StyledBadge count={totalMoneyTransfer} showZero />
                </span>
              </Link>
            </Menu.Item>
          </HasAccess>
          <HasAccess roles={['Masteradmin']} permissions={['dashboard-menu']} isLoading={<Spin />}>
            <Menu.Item
              key="report_not_approved"
              icon={<CancelScheduleSendIcon />}
              style={{
                paddingLeft: collapsed ? '0px' : '24px',
                background: pathName === 'report_not_approved' ? activeColor.background : '',
                color: pathName === 'report_not_approved' ? activeColor.color : undefined,
              }}
              onClick={() => {
                if (isMobileView) setSideBarToggle(!collapsed);
              }}
            >
              <Link to="/backoffice/report_not_approved">
                <span className="nav-text">ประวัติไม่อนุมัติ</span>
              </Link>
            </Menu.Item>
          </HasAccess>

          <HasAccess roles={['Masteradmin']} permissions={['dashboard-menu']} isLoading={<Spin />}>
            <Menu.Item
              key="report_approved"
              icon={<CheckCircleOutlineIcon />}
              style={{
                paddingLeft: collapsed ? '0px' : '24px',
                background: pathName === 'report_approved' ? activeColor.background : '',
                color: pathName === 'report_approved' ? activeColor.color : undefined,
              }}
              onClick={() => {
                if (isMobileView) setSideBarToggle(!collapsed);
              }}
            >
              <Link to="/backoffice/report_approved">
                <span className="nav-text">ประวัติอนุมัติ</span>
              </Link>
            </Menu.Item>
          </HasAccess>
          <HasAccess
            // key={1}
            roles={['Masteradmin']}
            permissions={['dashboard-menu']}
            // renderAuthFailed={<p>You are not authorized to access!</p>}
            isLoading={<Spin />}
          >
            <Menu.Item
              id="dashboard"
              key="dashboard"
              icon={<DashboardIcon />}
              style={{
                paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
                background: pathName === 'dashboard' ? activeColor.background : '',
                color: pathName === 'dashboard' ? activeColor.color : activeColor.colorBlack,
              }}
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/dashboard">
                <span
                  className="nav-text"
                  style={{
                    color: pathName === 'dashboard' ? activeColor.color : activeColor.colorBlack,
                  }}
                >
                  แดชบอร์ด
                </span>
              </Link>
            </Menu.Item>
          </HasAccess>
          <HasAccess
            // key={1}
            roles={['Masteradmin']}
            permissions={['dashboard-menu']}
            // renderAuthFailed={<p>You are not authorized to access!</p>}
            isLoading={<Spin />}
          >
            <Menu.Item
              id="active_user"
              key="active_user"
              icon={<GroupAddIcon />}
              style={{
                paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
                background: pathName === 'active_user' ? activeColor.background : '',
                color: pathName === 'active_user' ? activeColor.color : activeColor.colorBlack,
              }}
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/active_user">
                <span
                  className="nav-text"
                  style={{
                    color: pathName === 'active_user' ? activeColor.color : activeColor.colorBlack,
                  }}
                >
                  ยูสเซอร์ใช้งานปัจจุบัน
                </span>
              </Link>
            </Menu.Item>
          </HasAccess>

          {renderSettingAccountMenu()}
          {renderEntranceToPlay()}
          {renderMenuOwner()}
          {renderMenuSenior()}
          {renderMenuMaster()}
          {renderMenuAgent()}
          {renderEntranceToPlayStaff()}

          {parseDataUser?.type === 'Owner' && (
            <Menu.Item
              key="banner_owner"
              icon={<PublicIcon />}
              style={{
                paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
                background: pathName === 'banner_owner' ? activeColor.background : '',
                color: activeColor.color,
              }}
              onClick={() => {
                if (isMobileView) {
                  setSideBarToggle(!collapsed);
                }
              }}
            >
              <Link to="/backoffice/banner_owner">
                <span className="nav-text">ชื่อเว็บไซต์</span>
              </Link>
            </Menu.Item>
          )}

          <Menu.Item
            key="tutorial"
            icon={<PlayCircleIcon />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
              background: pathName === 'tutorial' ? activeColor.background : '',
              color: activeColor.color,
            }}
            onClick={() => {
              if (isMobileView) {
                setSideBarToggle(!collapsed);
              }
            }}
          >
            <Link to="/backoffice/tutorial">
              <span className="nav-text">วีดีโอ | วิธีการใช้งานระบบ</span>
            </Link>
          </Menu.Item>

          <Menu.Item
            key="changepassword"
            icon={<LockIcon />}
            style={{
              paddingLeft: isMobileView && collapsed === true ? '0px' : collapsed === true ? '0px' : '24px',
              background: pathName === 'changepassword' ? activeColor.background : '',
              color: activeColor.color,
            }}
            onClick={() => {
              if (isMobileView) {
                setSideBarToggle(!collapsed);
              }
            }}
          >
            <Link to="/backoffice/changepassword">
              <span className="nav-text">เปลี่ยนรหัสผ่าน</span>
            </Link>
          </Menu.Item>

          <Menu.Item
            key="logout"
            icon={<LogoutIcon />}
            onClick={() => {
              if (isMobileView) {
                setSideBarToggle(!collapsed);
              }

              Logout();
            }}
            style={{
              // background: Color.ocean,
              color: activeColor.color,
              position: 'relative',
            }}
          >
            <Link to="/">
              <span className="nav-text">{$t('Logout')}</span>
            </Link>
          </Menu.Item>
          {parseDataUser?.type === 'Masteradmin' && (
            <Menu.Item
              key="user_count"
              style={{
                // background: Color.ocean,
                color: activeColor.color,
                position: 'relative',
              }}
            >
              <span>จำนวนผู้ใช้งานออนไลน์: {activeUsersCount}</span>
            </Menu.Item>
          )}

          {isMobileView && (
            <>
              <div className="clearfix" style={{ marginTop: '65px', marginBottom: '65px' }} />
            </>
          )}
        </Menu>
      </Sider>
    </Fragment>
  );
};

export default AsidebarLayouts;
